import { specialitiesActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_SPECIALITY,
  FETCHING_SPECIALITY,
  FETCH_SPECIALITY_ERROR,
  FETCH_SPECIALITIES,
  FETCHING_SPECIALITIES,
  FETCH_SPECIALITIES_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_SPECIALITY,
  DELETE_SPECIALITY,
  ADD_SPECIALITY,
  EDIT_SPECIALITY,
  FORM_TOUCHED,
  NEW_FORM_SPECIALITY,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  SPECIALITY_FORM_ERROR,
  RESET_STATE
} = specialitiesActions

const initialState = {
  loadingSpeciality: false,
  loadingSpecialities: false,
  fetchSpecialityError: false,
  fetchSpecialitiesError: false,
  specialities: [],
  order: {
    column: 'nome',
    direction: 1
  },
  speciality: {
    nome: ''
  },
  specialitiesPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  specialityFormErrors: {},
  specialityFormTouched: false,
  modalOpen: false
}

const specialitySchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    }
  }
}

const SpecialityValidate = new ValidateFormObject(specialitySchema)

const specialities = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_SPECIALITY:
      formSchemaType = action.speciality._id ? 'edit' : 'add'
      return {
        ...state,
        speciality: action.speciality,
        specialityFormErrors: SpecialityValidate.validate({
          formObject: action.speciality,
          formSchemaType
        })
      }
    case SPECIALITY_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.speciality._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        specialityFormErrors: SpecialityValidate.validate({
          formObject: state.speciality,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_SPECIALITY:
      return {
        ...state,
        speciality: { ...initialState.speciality },
        specialityFormErrors: SpecialityValidate.validate({}),
        specialityFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        specialityFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_SPECIALITY:
      formSchemaType = (action.speciality || {})._id ? 'edit' : 'add'
      return {
        ...state,
        speciality: action.speciality,
        loadingSpeciality: false,
        fetchspecialityError: false,
        specialityFormTouched: false,
        specialityFormErrors: SpecialityValidate.validate({
          formObject: action.speciality,
          formSchemaType
        })
      }
    case FETCHING_SPECIALITY:
      return {
        ...state,
        loadingSpeciality: true,
        fetchSpecialityError: false
      }
    case DELETE_SPECIALITY:
      return {
        ...state,
        loadingSpecialities: false,
        fetchSpecialityError: false,
        specialities: state.specialities.map(speciality => {
          if (speciality._id === (action.speciality || {})._id) {
            return action.speciality
          }
          return speciality
        })
      }
    case FETCH_SPECIALITY_ERROR:
      return {
        ...state,
        loadingSpeciality: false,
        speciality: { ...initialState.speciality },
        fetchSpecialityError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        specialitiesPagination: {
          ...state.specialitiesPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        specialitiesPagination: {
          ...state.specialitiesPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_SPECIALITIES:
      return {
        ...state,
        loadingSpecialities: false,
        specialities: action.specialities,
        fetchSpecialitiesError: false,
        order: action.order,
        specialitiesPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_SPECIALITY:
      return {
        ...state,
        specialities: state.specialities.map(speciality => {
          if (speciality._id === action.speciality._id) {
            return action.speciality
          }
          return speciality
        }),
        loadingSpecialities: false,
        fetchSpecialityError: false,
        loadingSpeciality: false,
        fetchSpecialitiesError: false
      }
    case FETCHING_SPECIALITIES:
      return {
        ...state,
        loadingSpecialities: true,
        fetchSpecialitiesError: false
      }
    case FETCH_SPECIALITIES_ERROR:
      return {
        ...state,
        loadingSpecialities: false,
        fetchSpecialityError: action.error,
        loadingSpeciality: false
      }
    case ADD_SPECIALITY:
      return {
        ...state,
        loadingSpecialities: false,
        fetchSpecialityError: false,
        loadingSpeciality: false,
        specialities: [...state.specialities, action.speciality]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default specialities



// WEBPACK FOOTER //
// ./src/reducers/specialities.js